import request from '@/utils/request'

/**
 * 微信登录
 * @param {*} params openId：openIdnum
 * @returns
 */
export const WechatLogin = params => {
  return request({
    method: 'post',
    url: '/loginWeChat',
    data: params
  })
}

/**
 * 注册
 * @param {*} params account【账号】, password【密码】
 * @returns
 */
export const register = params => {
  return request({
    method: 'post',
    url: '/register',
    data: params
  })
}

/**
 * 登录
 * @param {*} params account , password
 * @returns
 */
export const Login = params => {
  return request({
    method: 'post',
    url: '/login',
    data: params
  })
}

/**
 * 微信登录绑定
 * @param {*} params openId：openIdnum ,token ,userId
 * @returns
 */
export const bindWechat = params => {
  return request({
    method: 'post',
    url: '/bindWechat',
    data: params
  })
}

/**
 * 分享注册
 * @param {*} params token, account, password
 * @returns
 */
export const shareRegister = params => {
  return request({
    method: 'post',
    url: '/shareRegister',
    data: params
  })
}
/**
 * 微信自动登录绑定
 * @param {*} params openId：openIdnum ,token ,userId， isAuto: 0 => 自动登录 .. 1 => 不自动登录
 * @returns
 */
export const WechatLogins = params => {
  return request({
    method: 'post',
    url: '/loginWeChatAuto',
    data: params
  })
}

/**
 * 微信授权获取 code
 * @param {*} params returnUrl: location.href, state: num
 * @returns
 */
export const AuthorizeMobile = params => {
  return request({
    method: 'GET',
    url: '/wechat/authorizeMobile',
    params
  })
}

/**
 * 微信获取 openid 和 access_token
 * @param {*} params code
 * @returns
 */
export const userInfoMobile = params => {
  return request({
    method: 'GET',
    url: '/wechat/userInfoMobile',
    params
  })
}

/**
 * 忘记密码 获取验证码
 * @param {*} params code
 * @returns
 */
export const ForgetCode = params => {
  return request({
    method: 'POST',
    url: '/resetPassword',
    params
  })
}

/**
 * 忘记密码 校验验证码
 * @param {*} params code
 * @returns
 */
export const ForgetCodeCheck = params => {
  return request({
    method: 'POST',
    url: '/resetPasswordSub',
    params
  })
}

/**
 * 忘记密码 修改密码
 * @param {*} params code
 * @returns
 */
export const ForgetChangePassword = params => {
  return request({
    method: 'POST',
    url: '/resetPasswordModify',
    params
  })
}

/**
 * 判断app版本
 * @param {*} params code
 * @returns
 */
export const getAppEdition = params => {
  return request({
    method: 'POST',
    url: '/login/getVersion',
    params
  })
}

export const IntoIndex = params => {
  return request({
    method: 'Get',
    url: '/loginMobile',
    params
  })
}
